import { RepresentativeUpdatePayload } from '~services/types';
import moment from 'moment';
import { parseCurrencyStringToNumber } from '~utils/formatters';
import { onlyNumbers } from '~constants/regularExpressions';
import { FormValues } from './types';

export const formatRepresentative = (
  representative: FormValues
): RepresentativeUpdatePayload => {
  return {
    name: representative?.name,
    email: representative?.email,
    cellphone: representative?.cellphone.replace(onlyNumbers, ''),
    cpf: representative?.cpf.replace(onlyNumbers, ''),
    birthday_date: moment(representative?.birthdayDate, 'DD/MM/YYYY').format(
      'YYYY-MM-DD'
    ),
    mother_name: representative?.motherName,
    politically_exposed_person: representative?.politicallyExposedPerson,
    declared_income: parseCurrencyStringToNumber(
      representative?.declaredIncome
    ),
    address: {
      cep: representative?.zipCode.replace(onlyNumbers, ''),
      state: representative?.state,
      city: representative?.city,
      neighborhood: representative?.neighborhood,
      street: representative?.street,
      number: representative?.number,
      complement: representative?.complement,
    },
  };
};
